import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/hotel-order-list',
            name: 'hotel-order-list',
            component: () => import(/* webpackChunkName: "page-admin-hotel-order-manage-orderList" */ `./1.0.2/index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "酒店订单"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "订单列表"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
